<template>
    <b-row no-gutters
        id="banner">
        <b-col>
            <div class="imageContainer">
                <b-img :src="require('../../assets/img/cardume.jpg')"
                    fluid
                    alt="Fish Group"></b-img>
                <div class="bannerText">
                    <b-row no-gutters>
                        <b-col cols="1"></b-col>
                        <b-col cols="4"
                            class="leftTextAlign">
                            <h1 class="textTitle whiteBarbos">
                                O melhor peixe do mercado. Encomende Online com a Barbosa Peixe.
                            </h1>
                            <p class="text whiteBarbos">
                                Somos especialistas na área alimentar com vasta oferta de produtos frescos e congelados para contemplar as necessidades do seu negócio.
                            </p>
                            <b-button pill
                                variant="outline-secondary"
                                class="bannerButton"
                                to="login">
                                Encomendar Agora
                            </b-button>
                        </b-col>
                        <b-col></b-col>
                    </b-row>
                </div>
            </div>
        </b-col>
    </b-row>
</template>

<script>
export default {
    name: 'Banner',
    props: {}
}
</script>
